var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.2,5H53.8C41.2,5,31,15.3,31,27.9v244.2c0,12.6,10.2,22.9,22.8,22.9h147.1c1.5,0,2.9-0.6,4-1.5h0 c1.4,0,2.7-0.5,3.7-1.5l57.8-54.6c1.1-1,1.6-2.5,1.6-3.9c0.6-0.9,0.9-2.1,0.9-3.3V27.9C269,15.3,258.8,5,246.2,5z M73.9,71.7 c0-3.5,2.8-6.3,6.3-6.3h139.5c3.5,0,6.3,2.8,6.3,6.3v11.4c0,3.5-2.8,6.3-6.3,6.3H80.3c-3.5,0-6.3-2.8-6.3-6.3V71.7z M73.9,111.5 c0-3.5,2.8-6.3,6.3-6.3h139.5c3.5,0,6.3,2.8,6.3,6.3v11.4c0,3.5-2.8,6.3-6.3,6.3H80.3c-3.5,0-6.3-2.8-6.3-6.3V111.5z M73.9,162.7 v-11.4c0-3.5,2.8-6.4,6.3-6.4h139.5c3.5,0,6.3,2.8,6.3,6.4v11.4c0,3.5-2.8,6.3-6.3,6.3H80.3C76.8,169,73.9,166.2,73.9,162.7z  M196.6,282.3v-32.2c0-13.3,10.8-24.1,24-24.1h35.5L196.6,282.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotas);
export default __webpack_public_path__ + "static/media/Notas.e6f9f2a360216bc84329978f841b7001.svg";
export { ForwardRef as ReactComponent };